import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "fieldKey"]
  static values = {
    autoGenerate: { type: Boolean, default: true }
  }

  connect() {
    // Track if user has manually edited the field key
    // Default to false so label changes will update the key
    // Only becomes true when user explicitly types in the key field
    this.manuallyEdited = false
  }

  generateKey() {
    // Off on records that already exist: their key is what stored answers,
    // logic rules and spreadsheet columns point at, so renaming the label must
    // never silently rewrite it. Only a fresh record derives its key.
    if (!this.autoGenerateValue) return
    // Only auto-generate if user hasn't manually edited the field key
    if (this.manuallyEdited) return
    
    const label = this.labelTarget.value
    const key = this.toSnakeCase(label)
    this.fieldKeyTarget.value = key
  }

  markAsManuallyEdited() {
    // If user clears the field, allow auto-generation again
    if (this.fieldKeyTarget.value === "") {
      this.manuallyEdited = false
    } else {
      this.manuallyEdited = true
    }
  }

  toSnakeCase(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s]/g, '') // Remove special characters
      .replace(/\s+/g, '_')        // Replace spaces with underscores
      .replace(/_+/g, '_')         // Replace multiple underscores with single
      .replace(/^_|_$/g, '')       // Remove leading/trailing underscores
  }
}
